import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

/**
 * Acessos do SGQ RH (07/08/2026) — separado do AuthContext principal
 * de propósito: o mapa de "quais salas do RH, com qual nível" só
 * interessa a quem efetivamente abriu o portal RH — a esmagadora
 * maioria de quem usa o SGQ nunca entra aqui, então não faz sentido
 * buscar isso no login de todo mundo (o AuthContext já busca só
 * "tenho acesso ou não", leve, pra decidir se mostra a opção).
 *
 * Mesma forma de `pode()` do AuthContext, só que lendo do mapa do RH.
 */
const AcessosRHContext = createContext(null);

const RANK_NIVEL = { nenhum: 0, ver: 1, editar: 2, gerenciar: 3 };

export function AcessosRHProvider({ children }) {
  const { API } = useAuth();
  const [acessosRH, setAcessosRH] = useState({});
  const [isMasterRH, setIsMasterRH] = useState(false);
  const [prontos, setProntos] = useState(false);

  const carregar = useCallback(() => {
    setProntos(false);
    API.get('/rh/acessos/meus', { timeout: 5000 })
      .then(res => {
        setAcessosRH(res.data?.acessos || {});
        setIsMasterRH(!!res.data?.master);
      })
      .catch(() => { setAcessosRH({}); setIsMasterRH(false); })
      .finally(() => setProntos(true));
  }, [API]);

  useEffect(() => { carregar(); }, [carregar]);

  const podeRH = (sala, areaOuNivel, nivelMinimo) => {
    if (isMasterRH) return true;
    const nivel = nivelMinimo ? areaOuNivel : null;
    const chave = nivel ? `${sala}›${areaOuNivel}` : `${sala}`;
    const efetivo = acessosRH[chave]?.nivel || 'nenhum';
    const minimoReal = nivelMinimo || areaOuNivel || 'ver';
    return RANK_NIVEL[efetivo] >= RANK_NIVEL[minimoReal];
  };

  return (
    <AcessosRHContext.Provider value={{ acessosRH, isMasterRH, podeRH, prontos, recarregarRH: carregar }}>
      {children}
    </AcessosRHContext.Provider>
  );
}

export const useAcessosRH = () => useContext(AcessosRHContext);
